import React, { useState } from "react";
import Link from "next/link";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

import PricingCards from "@components/Cards/PricingCard3";
import FeatureInfoPopup from "@components/Cards/FeatureImagePopup";

import "swiper/css";
import "swiper/css/controller";
import "swiper/css/pagination";
import SignatureRegister from "components/SignatureRegister";
import { createRegisterURL } from "@utils/signature_owner";
import CalComModal from "@components/Modal/CalComModal";

const PricingTable2 = ({ isMonthly, monthlyPricing, yearlyPricing }) => {
  const [imagePopup, setImagePopup] = useState(null);
  const [registerPopup, setRegisterPopup] = useState(false);
  const [showCalcomModal, setShowCalcomModal] = useState(false);
  return (
    <div className="relative w-full  pb-10 pt-8 md:px-10 px-0">
      <Swiper
        breakpoints={{
          0: {
            slidesPerView: 1.2,
            centeredSlides: true,
          },
          640: {
            slidesPerView: 2.2,
            centeredSlides: true,
          },
          1024: {
            slidesPerView: 2.5,
            centeredSlides: false,
          },
          1120: {
            slidesPerView: 3,
            centeredSlides: false,
          },
          1280: {
            slidesPerView: 4,
            centeredSlides: false,
          },
        }}
        slidesPerView={"auto"} // gets overridden by breakpoints
        centeredSlides={true} // default, overridden by breakpoints
        spaceBetween={10}
        pagination={{
          el: ".swiper-pagination",
          clickable: true,
        }}
        modules={[Pagination]}
        className="relative [mask:linear-gradient(90deg,transparent,#fff_5%,#fff_95%,transparent)] xxl:[mask:none] mx-auto max-w-[1600px]"
        initialSlide={0}
      >
        {isMonthly
          ? monthlyPricing.map((pricingCard, index) => {
              return (
                <SwiperSlide key={index} className="[height:auto_!important]">
                  <div className="sm:px-1 pb-20 max-w-[min(400px,100%)] mx-auto h-full">
                    <PricingCards
                      key={index}
                      title={pricingCard.title}
                      description={pricingCard.description}
                      price={pricingCard.price}
                      pricingType={pricingCard.pricingType}
                      pricingTag={pricingCard.pricingTag}
                      featuresTitle={pricingCard.featuresTitle}
                      featuresIcon={pricingCard.featuresIcon}
                      features={pricingCard.features}
                      pricingLink={pricingCard.pricingLink}
                      bgColor={pricingCard.bgColor}
                      quantityName={pricingCard.quantityName}
                      recommended={pricingCard.recommended}
                      isAnnualBilling={false}
                      owner={""}
                      transparent={pricingCard.transparent ? true : false}
                      buttonText={pricingCard.buttonText || "Subscribe Now"}
                      buttonUrl={pricingCard.buttonUrl}
                      trialButtonText={"Start 7-days free trial"}
                      trialButtonUrl={createRegisterURL({
                        from: "PRICING_PAGE",
                      })}
                      conditions={{
                        navigateRegister: true,
                        navigateCheckout: true,
                      }}
                      noCreditCard
                      setImagePopup={setImagePopup}
                      setShowCalcomModal={setShowCalcomModal}
                      additionalSeatPrice={pricingCard?.additionalSeatPrice}
                      setRegisterPopup={setRegisterPopup}
                    />
                  </div>
                </SwiperSlide>
              );
            })
          : yearlyPricing.map((pricingCard, index) => {
              return (
                <SwiperSlide key={index} className="[height:auto_!important]">
                  <div className="sm:px-1 pb-20 max-w-[min(400px,100%)] mx-auto h-full">
                    <PricingCards
                      key={index}
                      title={pricingCard.title}
                      description={pricingCard.description}
                      price={pricingCard.price}
                      pricingType={pricingCard.pricingType}
                      pricingTag={pricingCard.pricingTag}
                      featuresTitle={pricingCard.featuresTitle}
                      featuresIcon={pricingCard.featuresIcon}
                      features={pricingCard.features}
                      pricingLink={pricingCard.pricingLink}
                      bgColor={pricingCard.bgColor}
                      quantityName={pricingCard.quantityName}
                      recommended={pricingCard.recommended}
                      isAnnualBilling={true}
                      owner={""}
                      transparent={pricingCard.transparent ? true : false}
                      buttonText={pricingCard.buttonText || "Subscribe Now"}
                      buttonUrl={pricingCard.buttonUrl}
                      trialButtonText={"Start 7-days free trial"}
                      trialButtonUrl={createRegisterURL({
                        from: "PRICING_PAGE",
                      })}
                      conditions={{
                        navigateRegister: true,
                        navigateCheckout: true,
                      }}
                      noCreditCard
                      setImagePopup={setImagePopup}
                      setShowCalcomModal={setShowCalcomModal}
                      additionalSeatPrice={pricingCard?.additionalSeatPrice}
                      setRegisterPopup={setRegisterPopup}
                    />
                  </div>
                </SwiperSlide>
              );
            })}
      </Swiper>
      <div className="w-full flex justify-between gap-4 flex-wrap max-w-screen-xl mx-auto px-4">
        <div>
          <div className="text-left text-xs">*Fair Usage Policy Applicable</div>
          <div className="text-left text-xs">
            *SMS Credits have to be purchased separately
          </div>
        </div>
        {/* <div className="">
          <Link
            href={`#bolosign-pricing-comparison-table`}
            className="text-xl w-fit mx-auto px-10 py-2 bg-transparent text-gray-800 border border-gray-700 rounded-full hover:bg-gray-100"
          >
            Compare Plan Details
          </Link>
        </div> */}
      </div>

      <div className="absolute top-1 left-0 w-full [--swiper-pagination-color:black] [--swiper-pagination-bullet-width:14px] [--swiper-pagination-bullet-height:14px]">
        <div className="swiper-pagination"></div>
      </div>

      {showCalcomModal && (
        <CalComModal
          calLink="boloforms/enterprise"
          close={() => setShowCalcomModal(false)}
        />
      )}

      {imagePopup && (
        <FeatureInfoPopup
          image={imagePopup}
          close={() => setImagePopup(null)}
        />
      )}
      <SignatureRegister
        mode="register"
        isPopupOpen={registerPopup}
        setIsPopupOpen={setRegisterPopup}
      />
    </div>
  );
};

export default PricingTable2;
